import { Container } from "@mui/material";
import Banner from "components/templates/Banner";
import Tabs from "components/templates/Tabs";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AssetListing from "./AssetListing/AssetListing";
import HandoverStatus from "./HandoverStatus";
import ECarsListing from "./ECarsListing/ECarsListing";

const tabLabels = [
    "Asset Listing",
    "E Cars",
    "Handover Status",
];

const slugify = (label: string) => label.toLowerCase().replace(/\s+/g, "-");

export default function AssetManagement() {
    const nav = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState(0);

    // On first load, read query ?tab=... and set the active tab
    useEffect(() => {
        const q = searchParams.get("tab");
        if (!q) return;
        const idx = tabLabels.findIndex((l) => slugify(l) === q);
        if (idx >= 0) setTab(idx);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // When tab changes, update the query so refresh preserves it
    useEffect(() => {
        const label = tabLabels[tab];
        if (!label) return;
        const slug = slugify(label);
        setSearchParams({ tab: slug });
        nav(`/asset-management?tab=${slug}`, { replace: true });
    }, [tab, nav, setSearchParams]);

    return (
        <div>
            <Container maxWidth="lg">
                <Banner heading="Asset Management"></Banner>
                <Tabs
                    value={tab}
                    onChange={(tab) => setTab(tab)}
                    tabs={[
                        { label: "Items Listing", element: <AssetListing /> },
                        { label: "E Cars", element: <ECarsListing /> },
                        { label: "Handover Status", element: <HandoverStatus /> },
                    ]}
                />
            </Container>
        </div>
    );
}

